import React from 'react';
import {
  Container,
  Grid,
  Paper,
  Typography,
} from '@mui/material';
import {
  Inventory as InventoryIcon,
  LocalBar as LocalBarIcon,
  Warning as WarningIcon,
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext.tsx';

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  const statCards = [
    {
      title: 'Total Items',
      value: '—',
      icon: <InventoryIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
      description: 'Items tracked in inventory',
    },
    {
      title: 'Bar Stock',
      value: '—',
      icon: <LocalBarIcon sx={{ fontSize: 40, color: 'secondary.main' }} />,
      description: 'Bottles and kegs on hand',
    },
    {
      title: 'Low Stock Alerts',
      value: '—',
      icon: <WarningIcon sx={{ fontSize: 40, color: 'warning.main' }} />,
      description: 'Items below reorder level',
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Inventory Dashboard
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Welcome, {user?.email} ({user?.type})
      </Typography>

      <Grid container spacing={3}>
        {statCards.map((card) => (
          <Grid item xs={12} sm={6} md={4} key={card.title}>
            <Paper elevation={2} sx={{ p: 3, textAlign: 'center' }}>
              {card.icon}
              <Typography variant="h4" sx={{ my: 1 }}>
                {card.value}
              </Typography>
              <Typography variant="h6" gutterBottom>
                {card.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {card.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Dashboard;
